/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react';
import { useInterval, useRouter } from '../../helpers/customHooks';
import './monitor.scss';

import * as DateFns from 'date-fns';
import { Row, Container, Col } from 'react-bootstrap';
import { routeToDate, cleanFetch, saveDataEventsOnLocalStorage } from '../../helpers/helpers';
import { LOAD_MONITOR_DATA_TIME } from '../../config/constants';

import Navbar from '../Navbar/NavBar';
import Loader from '../Shared/Loader';
import MonitorTable from './monitorUtils/MonitorTable';
import { DaySelector } from '../Shared/Filters/DaySelector';
import { useMonitorState, useMonitorDispatch } from '../../store/hooks/monitor';

export default () => {
  
  const { pathname } = useRouter();
  const monitorData = useMonitorState() || {};
  const { getMonitorData, cleanMonitorData } = useMonitorDispatch();
  
  const [modalShow, setModalShow] = useState<React.ReactNode>(null);
  const selectedDate = routeToDate(pathname, 2);
  const dateTs = new Date(selectedDate).getTime();
  const monitorEvents:any=[];

  if(monitorData[dateTs]){
    monitorData[dateTs].map(event => {
      monitorEvents.push(event.allData);
    });
  }

  useEffect(() => {
    return () => {
      cleanFetch();
      cleanMonitorData();
    };
  }, []);

  useEffect(() => {
    getMonitorData();
  }, [pathname]);

  useEffect(()=>{
    if(monitorEvents){
      saveDataEventsOnLocalStorage(monitorEvents.map((event:any) => Number.isNaN(+event.gameId) ? event._id : event.gameId));
    }
  }, [monitorData]);

  useInterval(() => {
    getMonitorData();
  }, LOAD_MONITOR_DATA_TIME);

  return (
    <Fragment>
      <Navbar />
      {modalShow}
      <Container className="container-00 container-monitor">
        <div className="profiles-pp">
          <h4>Monitor</h4>
        </div>
        <Row>
          <Col lg={12} xs={12}>
            <div className="head-filters-01">
              <DaySelector />
              <label
                style={{
                  fontFamily: 'Roboto-Regular, sans-serif',
                  position: 'absolute',
                  right: '43%',
                  color: '#000000',
                  paddingTop: '10px',
                  fontSize: '16px',
                  lineHeight: '24px'
                }}
              >{DateFns.format(selectedDate, 'EEEE, LLLL do')}</label>
            </div>
            <div className="monitor adjust-height-monitor">
              <Loader>
                <MonitorTable
                  monitorData={monitorData[dateTs]}
                  setModalShow={setModalShow}
                />
              </Loader>
            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
